import React from 'react';
import Landing from '../../components/dashboard/Landing';

const DashLandingPage = () => {
  return (
    <div>
      <Landing />
    </div>
  );
};

export default DashLandingPage;
